/**
 * Minúsculas y sin marcas diacríticas: «Investigación» y «investigacion» quedan iguales.
 * Mucha gente escribe sin tildes desde el celular; el buscador, la terminal y /umbral
 * comparan siempre con este texto.
 */
export function fold(s: string): string {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
